export const getShortTitle = (title: string): string => {
    if (!title)
        return '';
    return title.length > 100 ? title.slice(0, 50) + '...' : title;
}
